import React from "react";
import { useLanguage } from "../context/LanguageContext";

const LocationMap = () => {
  const { t } = useLanguage();
  const localities = [
    "Secunderabad",
    "Nagaram",
    "Dammaiguda",
    "ECIL",
    "Sainikpuri",
    "Kushaiguda",
    "Kapra",
    "AS Rao Nagar",
  ];

  return (
    <section className="py-24 bg-[#0F4C5C] dark:bg-[#06181C] text-white overflow-hidden transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center mb-16">
          {/* Left Column: Text */}
          <div className="lg:col-span-6 flex flex-col justify-center space-y-6 text-left">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-white leading-tight">
              {t.location.heading}
            </h2>

            <p className="text-white/80 text-base md:text-lg leading-relaxed pt-2">
              {t.location.desc1}
            </p>

            <p className="text-white/80 text-base md:text-lg leading-relaxed">
              {t.location.desc2}
            </p>
          </div>

          {/* Right Column: Google Maps Embed */}
          <div className="lg:col-span-6 w-full h-[380px] md:h-[450px] bg-white rounded-3xl overflow-hidden shadow-2xl border border-white/20 relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.1091599818817!2d78.57149027581561!3d17.47839369970894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9d64f9c20e93%3A0x7df2ea8ca4e570f5!2sKrishna&#39;s%20Dental!5e0!3m2!1sen!2sin!4v1717290117094!5m2!1sen!2sin"
              title="Dr. Krishna's Dental Location Map"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        {/* Bottom Section: Serving Localities */}
        <div className="pt-8 border-t border-white/10 text-center">
          <p className="text-white/70 text-sm md:text-base font-medium tracking-wide mb-6">
            We proudly serve patients from:
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            {localities.map((place, index) => (
              <span
                key={index}
                className="px-6 py-2.5 rounded-full border border-white/25 text-white text-sm font-medium backdrop-blur-sm hover:bg-white/10 transition-all duration-300"
              >
                {place}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationMap;
